var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "news-page" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: { "background-image": "url('/images/ban1.jpg')" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "wp" }, [
        _c("div", { staticClass: "g-top" }, [
          _c("div", { staticClass: "tab" }, [
            _c("ul", [
              _c("li", { class: { on: _vm.activeTab === "company" } }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveTab("company")
                      },
                    },
                  },
                  [_vm._v("公司新闻")]
                ),
              ]),
              _vm._v(" "),
              _c("li", { class: { on: _vm.activeTab === "product" } }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        return _vm.setActiveTab("product")
                      },
                    },
                  },
                  [_vm._v("最新产品")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cur" }, [
            _vm._v("\n          当前位置：\n          "),
            _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
            _vm._v(" >\n          "),
            _c("a", { attrs: { href: "javascript:void(0)" } }, [
              _vm._v("新闻资讯"),
            ]),
            _vm._v(" >\n          "),
            _vm.activeTab === "company"
              ? _c("span", [_vm._v("公司新闻")])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "product"
              ? _c("span", [_vm._v("最新产品")])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.showingNewsDetail
        ? _c("div", { staticClass: "wp" }, [
            _c(
              "ul",
              { staticClass: "m-list4" },
              _vm._l(_vm.allNews, function (news) {
                return _c("li", { key: news.id }, [
                  _c(
                    "a",
                    {
                      staticClass: "con",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.viewNewsDetail(news)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "pic" }, [
                        _c("img", {
                          attrs: { src: news.newImg, alt: news.title },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("h3", [_vm._v(_vm._s(news.newNameEn))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "date" }, [
                        _vm._v(_vm._s(news.createTime)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "desc" }, [
                        _vm._v(_vm._s(news.newSynopsisCn)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "btn" }, [_vm._v("查看详情")]),
                    ]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showingNewsDetail
        ? _c("div", [
            _c(
              "div",
              [
                _c("component-news-detail", {
                  attrs: {
                    article: _vm.currentArticle,
                    "all-news": _vm.allNews,
                  },
                  on: {
                    "close-detail": _vm.closeNewsDetail,
                    "view-article": _vm.handleViewArticle,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pages" }, [_c("ul")])
  },
]
render._withStripped = true

export { render, staticRenderFns }